import { computed, watchEffect } from "vue";
import { type RouteLocationAsRelativeGeneric, type RouteParamsGeneric, useRoute, useRouter } from "vue-router";
import useExperiences from "@/components/MyExperiences/composables/useExperiences.js";
import { getSingleParam } from "../utils/utils";

export const useExistingApplicationRedirect = () => {
  const route = useRoute();
  const router = useRouter();
  const { experiences, experiencesIsLoading, participantId } = useExperiences();

  const sessionId = computed<string | undefined>(() => getSingleParam(route.params?.sessionId));

  const matchingExistingExperience = computed(() =>
    experiences.value?.find((experience) => experience?.session_id === sessionId.value),
  );

  const isResolvingExistingApplication = computed<boolean>(
    () =>
      route.name === "new-application" &&
      (!participantId.value ||
        experiencesIsLoading.value ||
        Boolean(matchingExistingExperience.value?.application_id)),
  );

  watchEffect(async () => {
    if (route.name === "new-application" && matchingExistingExperience.value?.application_id) {
      const params: RouteParamsGeneric = {
        ...route.params,
        applicationId: matchingExistingExperience.value.application_id,
      };
      delete params.sessionId;
      delete params.programPageId;

      const updatedRoute: RouteLocationAsRelativeGeneric = {
        name: "modify-application",
        params,
        query: route.query,
      };

      await router.replace(updatedRoute);
    }
  });

  return {
    matchingExistingExperience,
    isResolvingExistingApplication,
  };
};
